import { render, staticRenderFns } from "./ScreenLaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=template&id=cb9434e8&lang=true&"
import script from "./ScreenLaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports